import React, { useState, useEffect } from "react";
import Tab from "../../sidebar/components/tabs";
import Tabs from "./tabs/tabs";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails, selectUser } from "../../../redux/slices/userSlice";
import { selectCompanyDashboard } from "../../../redux/slices/companyDashboardSlice";
import { useLocation } from "react-router-dom";

function CompanySettingModel({ setstate, setPopup}) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState(1);
  const State = useSelector(selectUser);
  const { userDetails } = State;
  const company_image = userDetails?.user?.company_image_url;
  const isServiceOwner = userDetails?.user?.service_owner;
  const isAdmin = userDetails?.user?.admin;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const service_id = params.get("service_id");

  useEffect(() => {
    if (service_id) {
      setTab(4);
      return;
    }

    if (isAdmin) {
      if (location.pathname?.includes("personal_dashboard")) {
        setTab(1);
      } else {
        setTab(2);
      }
    } else if (isServiceOwner) {
      setTab(4);
    } else {
      setTab(1);
    }
  }, [isAdmin, isServiceOwner, service_id]);

  useEffect(() => {
    dispatch(getUserDetails());
  }, [dispatch]);

  return (
    <div className="line-head flex flex-col w-[1300px] h-[800px]  rounded-[24px] bg-[#363D50]">
      <div className="flex flex-col customize_setting_model">
        <div className="!p-4 flex justify-between items-center model_header">
          <div className="flex flex-start items-center gap-[16px]">
            <div>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.61 28.0062L11.5491 28.0002L11.4879 27.9999C11.1265 27.9977 10.7755 27.8781 10.488 27.6591L7.72966 25.607C7.36718 25.3202 7.12676 24.9065 7.05718 24.4493C6.98694 23.9877 7.09616 23.5168 7.36229 23.1333L7.3707 23.1208C7.73253 22.5866 7.96248 21.9741 8.04167 21.3337C8.12085 20.6933 8.04708 20.0432 7.82629 19.4369L7.7597 19.2594C7.59628 18.7115 7.31043 18.2077 6.92346 17.7862C6.52221 17.3491 6.02353 17.0128 5.46793 16.8046L5.24167 16.7198H5.03616C4.66934 16.5516 4.3684 16.263 4.18527 15.8992C3.97369 15.479 3.9365 14.9922 4.08169 14.5446L5.19034 11.0294L5.20006 10.9906C5.25454 10.7732 5.35484 10.5699 5.49424 10.3944C5.63365 10.2189 5.80894 10.0752 6.00838 9.97298L6.01074 9.97176C6.19354 9.87758 6.39354 9.82146 6.59864 9.80681C6.80375 9.79216 7.00968 9.81932 7.204 9.88657L7.21475 9.89019C7.81773 10.0931 8.46113 10.1457 9.08906 10.0434C9.71698 9.94111 10.3104 9.68704 10.8178 9.30321L11.0091 9.15611L11.0183 9.14872C11.4768 8.78289 11.8473 8.31885 12.1026 7.79079C12.3579 7.26273 12.4914 6.68411 12.4934 6.09758L12.4934 5.77317L12.4934 5.76731C12.4913 5.30314 12.6727 4.85695 12.9981 4.52589C13.3218 4.1966 13.7618 4.00774 14.2232 3.99984H17.6113C17.8321 4.00063 18.0505 4.04493 18.2542 4.13021C18.4576 4.21538 18.6422 4.33978 18.7976 4.49627C19.1359 4.84124 19.3238 5.30625 19.32 5.78951V6.16224C19.3116 6.73419 19.4367 7.30029 19.6853 7.81557C19.9359 8.33495 20.3051 8.78815 20.763 9.13864L20.776 9.14856L20.9288 9.25973C21.3981 9.60947 21.9446 9.84138 22.5223 9.93585C23.1021 10.0306 23.6961 9.98425 24.254 9.80062L24.2585 9.79913L24.7038 9.65513L24.7129 9.65211C24.927 9.58113 25.1533 9.554 25.3781 9.57235C25.603 9.59069 25.8218 9.65414 26.0216 9.75889C26.2214 9.86365 26.3981 10.0076 26.5411 10.1821C26.684 10.3566 26.7904 10.5581 26.8538 10.7746L26.8573 10.7867L27.9146 14.1591C28.055 14.6066 28.0166 15.0911 27.8075 15.5109C27.5988 15.9297 27.2363 16.2516 26.7958 16.4093L26.7928 16.4104L26.5443 16.4974C25.9502 16.6945 25.4129 17.0334 24.9791 17.4848C24.5424 17.9393 24.2238 18.494 24.0513 19.1002C23.8927 19.6532 23.8551 20.2339 23.9413 20.8027C24.0276 21.3722 24.2359 21.9164 24.552 22.398L24.559 22.4088L24.913 22.9261L24.9154 22.9297C25.182 23.3165 25.2905 23.7908 25.2186 24.2551C25.1468 24.7187 24.9006 25.1375 24.5304 25.4256L24.5289 25.4268L21.8567 27.4874L21.8548 27.4889C21.676 27.6252 21.4713 27.7236 21.2532 27.7781C21.0343 27.8328 20.8065 27.8421 20.5839 27.8055C20.3612 27.7688 20.1484 27.687 19.9586 27.565C19.7688 27.443 19.6059 27.2835 19.4801 27.0962L19.4715 27.0835L19.312 26.8575C18.9699 26.3496 18.506 25.9353 17.9624 25.6527C17.4129 25.3669 16.7998 25.225 16.1806 25.2402L16.1789 25.2403C15.5939 25.2554 15.0207 25.4079 14.5055 25.6853C13.9903 25.9627 13.5475 26.3574 13.2128 26.8375L12.8985 27.2885L12.8911 27.2996C12.7647 27.4889 12.601 27.6503 12.4099 27.7739C12.2319 27.889 12.0336 27.969 11.8259 28.0098C11.754 28.0144 11.6818 28.0132 11.61 28.0062ZM5.73902 24.6499C5.86052 25.4483 6.28313 26.1699 6.92005 26.6665L9.68005 28.7198C10.1977 29.1141 10.8294 29.3293 11.48 29.3332C11.653 29.3501 11.8271 29.3501 12 29.3332C12.404 29.2656 12.7899 29.1159 13.1339 28.8935C13.4779 28.6711 13.7726 28.3805 14 28.0398L14.3067 27.5998C14.5218 27.2913 14.8065 27.0376 15.1377 26.8592C15.4689 26.6809 15.8373 26.5829 16.2134 26.5732C16.6075 26.5635 16.9976 26.6538 17.3473 26.8356C17.697 27.0175 17.995 27.285 18.2134 27.6132L18.3734 27.8398C18.6007 28.1782 18.8949 28.4664 19.2378 28.6867C19.5807 28.9071 19.9651 29.0549 20.3673 29.1211C20.7695 29.1873 21.181 29.1705 21.5765 29.0717C21.9719 28.9728 22.3429 28.7941 22.6667 28.5465L25.3467 26.4798C25.9867 25.9828 26.4123 25.2598 26.5362 24.459C26.6602 23.6583 26.4731 22.8404 26.0134 22.1732L25.6667 21.6665C25.456 21.3454 25.3171 20.9826 25.2596 20.6029C25.2021 20.2232 25.2272 19.8356 25.3334 19.4665C25.4461 19.0695 25.6546 18.7062 25.9405 18.4086C26.2265 18.1111 26.5812 17.8883 26.9734 17.7598L27.24 17.6665C28.0068 17.3935 28.6379 16.834 29.0008 16.1056C29.3638 15.3771 29.4304 14.5364 29.1867 13.7598L28.1334 10.3998C28.0196 10.0115 27.8289 9.65007 27.5724 9.33707C27.316 9.02407 26.9991 8.76592 26.6408 8.57802C26.2824 8.39013 25.8899 8.27634 25.4866 8.24343C25.0833 8.21053 24.6775 8.25919 24.2934 8.3865L23.84 8.53317C23.4849 8.65057 23.1066 8.68035 22.7375 8.61999C22.3684 8.55963 22.0193 8.41091 21.72 8.1865L21.5734 8.07984C21.2814 7.85634 21.046 7.56734 20.8862 7.23614C20.7264 6.90495 20.6466 6.54084 20.6534 6.17317V5.79984C20.6599 4.96254 20.3338 4.15689 19.7467 3.55984C19.4675 3.27777 19.1353 3.05365 18.7692 2.90035C18.4031 2.74704 18.0103 2.66757 17.6134 2.6665H14.2134C13.3976 2.67705 12.619 3.00943 12.0472 3.59128C11.4753 4.17314 11.1565 4.95735 11.16 5.77317V6.09317C11.1588 6.4802 11.0707 6.86201 10.9022 7.21046C10.7337 7.5589 10.4892 7.86511 10.1867 8.1065L10.0134 8.23984C9.67917 8.49267 9.28827 8.66005 8.87466 8.72743C8.46104 8.79482 8.03723 8.76017 7.64005 8.6265C7.27527 8.50027 6.88867 8.44937 6.50364 8.47687C6.11862 8.50437 5.74318 8.60971 5.40005 8.7865C5.03159 8.97542 4.70774 9.24088 4.4502 9.56511C4.19266 9.88934 4.00736 10.2649 3.90671 10.6665L2.81338 14.1332C2.55984 14.9148 2.62486 15.7648 2.99433 16.4988C3.36379 17.2327 4.00788 17.7913 4.78671 18.0532H5.00005C5.35932 18.1878 5.68179 18.4053 5.94126 18.6879C6.20073 18.9705 6.38989 19.3104 6.49338 19.6798L6.57338 19.8932C6.72202 20.3013 6.77172 20.739 6.71841 21.1701C6.6651 21.6012 6.5103 22.0135 6.26671 22.3732C5.80634 23.0367 5.61752 23.8514 5.73902 24.6499ZM20 15.9998C20 18.209 18.2092 19.9998 16 19.9998C13.7909 19.9998 12 18.209 12 15.9998C12 13.7907 13.7909 11.9998 16 11.9998C18.2092 11.9998 20 13.7907 20 15.9998ZM21.3334 15.9998C21.3334 18.9454 18.9456 21.3332 16 21.3332C13.0545 21.3332 10.6667 18.9454 10.6667 15.9998C10.6667 13.0543 13.0545 10.6665 16 10.6665C18.9456 10.6665 21.3334 13.0543 21.3334 15.9998Z"
                  fill="#A5AEBC"
                />
              </svg>
            </div>
            <span className="text-sm font-bold text-white">
              Settings
            </span>
          </div>
          <div className="flex h-[40px] justify-end items-center">
            <svg
              className="cursor-pointer"
              onClick={() => {
                setPopup(false);
              }}
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.4099 12.0002L17.7099 7.71019C17.8982 7.52188 18.004 7.26649 18.004 7.00019C18.004 6.73388 17.8982 6.47849 17.7099 6.29019C17.5216 6.10188 17.2662 5.99609 16.9999 5.99609C16.7336 5.99609 16.4782 6.10188 16.2899 6.29019L11.9999 10.5902L7.70994 6.29019C7.52164 6.10188 7.26624 5.99609 6.99994 5.99609C6.73364 5.99609 6.47824 6.10188 6.28994 6.29019C6.10164 6.47849 5.99585 6.73388 5.99585 7.00019C5.99585 7.26649 6.10164 7.52188 6.28994 7.71019L10.5899 12.0002L6.28994 16.2902C6.19621 16.3831 6.12182 16.4937 6.07105 16.6156C6.02028 16.7375 5.99414 16.8682 5.99414 17.0002C5.99414 17.1322 6.02028 17.2629 6.07105 17.3848C6.12182 17.5066 6.19621 17.6172 6.28994 17.7102C6.3829 17.8039 6.4935 17.8783 6.61536 17.9291C6.73722 17.9798 6.86793 18.006 6.99994 18.006C7.13195 18.006 7.26266 17.9798 7.38452 17.9291C7.50638 17.8783 7.61698 17.8039 7.70994 17.7102L11.9999 13.4102L16.2899 17.7102C16.3829 17.8039 16.4935 17.8783 16.6154 17.9291C16.7372 17.9798 16.8679 18.006 16.9999 18.006C17.132 18.006 17.2627 17.9798 17.3845 17.9291C17.5064 17.8783 17.617 17.8039 17.7099 17.7102C17.8037 17.6172 17.8781 17.5066 17.9288 17.3848C17.9796 17.2629 18.0057 17.1322 18.0057 17.0002C18.0057 16.8682 17.9796 16.7375 17.9288 16.6156C17.8781 16.4937 17.8037 16.3831 17.7099 16.2902L13.4099 12.0002Z"
                fill="white"
              />
            </svg>
          </div>
        </div>

        <div className={`animation flex flex-row settings_content_wrapper`}>
          <div
            className={`animation !pl-[24px] !pt-[12px] w-[280px] setting_sidebar`}
          >
            <div className="w-full bg-[#363D50]">
              <div>
                <Tab
                  nohover={true}
                  childrenStyle={{
                    fontSize: "14px",
                    fontWeight: 700,
                    color: "#fff",
                    letterSpacing: "0.02em",
                    lineHeight: "21px",
                  }}
                  svg={true}
                  active={false}
                >
                  Personal
                </Tab>
                <Tab
                  onClick={() => setTab(1)}
                  childrenStyle={{
                    marginLeft: "20px",
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#A5AEBC",
                    letterSpacing: "0.02em",
                    lineHeight: "21px",
                  }}
                  active={tab === 1}
                >
                  Account
                </Tab>
              </div>
              <div>
                {(isAdmin || isServiceOwner) && (
                  <Tab
                    svg={true}
                    childrenStyle={{
                      fontSize: "14px",
                      fontWeight: 700,
                      color: "#fff",
                      letterSpacing: "0.02em",
                      lineHeight: "21px",
                    }}
                    active={false}
                  >
                    Administration
                  </Tab>
                )}
                {isAdmin && (
                  <Tab
                    childrenStyle={{
                      marginLeft: "20px",
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#A5AEBC",
                      letterSpacing: "0.02em",
                      lineHeight: "21px",
                    }}
                    active={tab === 2}
                    onClick={() => setTab(2)}
                  >
                    {userDetails?.user?.company_name} settings
                  </Tab>
                )}
                {isAdmin && (
                  <Tab
                    childrenStyle={{
                      marginLeft: "20px",
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#A5AEBC",
                      letterSpacing: "0.02em",
                      lineHeight: "21px",
                    }}
                    active={tab === 3}
                    onClick={() => setTab(3)}
                  >
                    Integrations
                  </Tab>
                )}
                {(isAdmin || isServiceOwner) && (
                  <Tab
                    childrenStyle={{
                      marginLeft: "20px",
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#A5AEBC",
                      letterSpacing: "0.02em",
                      lineHeight: "21px",
                    }}
                    active={tab === 4}
                    onClick={() => setTab(4)}
                  >
                    Manage services
                  </Tab>
                )}
                {isAdmin && (
                  <Tab
                    childrenStyle={{
                      marginLeft: "20px",
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#A5AEBC",
                      letterSpacing: "0.02em",
                      lineHeight: "21px",
                    }}
                    active={tab === 5}
                    onClick={() => setTab(5)}
                  >
                    Manage employees
                  </Tab>
                )}
              </div>
            </div>
          </div>
          <div className="flex-1 text-left">
            <Tabs Tab={tab} setModel={setPopup} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanySettingModel;
